import {useState} from 'react';
import {connect} from 'react-redux';
import {Toast} from '@shipwell/shipwell-ui';
import PropTypes from 'prop-types';
import {useGetUpsAccountsQuery} from '../hook/useGetUpsAccountsQuery';
import {useCreateUpsAccountMutation} from '../hook/useCreateUpsAccountMutation';
import UpsConnectedAccountsTable from './components/upsConnectAccountsTable';
import PageHeader from 'App/common/pageHeader';
import UPSRegistrationForm from 'App/formComponents/forms/upsRegistration';
import {unpackErrors, cleanPayload} from 'App/utils/globals';
import './styles.scss';

/**
 * UPS Registration Container
 * @param {*} props
 */
const UPSRegistration = (props) => {
  const {isUPSEnabled, company} = props;
  const [submitError, setSubmitError] = useState(null);
  const [shouldOpenForm, setShouldOpenForm] = useState(false);

  const {isUpsAuthenticated, upsQuery} = useGetUpsAccountsQuery(company?.id);

  const {mutateAsync: createUpsAccount} = useCreateUpsAccountMutation({
    onSuccess: () => {
      setShouldOpenForm(false);
    }
  });

  const handleCancel = () => {
    setShouldOpenForm(false);
  };

  /**
   * Submit UPS Account Form
   * @param {Object} values
   * @param {Object} actions
   */
  const handleSubmit = async (values, {setSubmitting, setErrors}) => {
    try {
      await createUpsAccount(cleanPayload(values));
    } catch (error) {
      if (error && error.error_description) {
        setSubmitError(error.error_description);
      }
      if (error && error.field_errors) {
        setErrors(unpackErrors(error.field_errors, {}));
      }
    }
    setSubmitting(false);
  };

  return (
    <div className="ups-registration-wrapper">
      <PageHeader title="UPS Registration" />
      <div className="ups-registration-container">
        {isUpsAuthenticated && !shouldOpenForm ? (
          <div className="my-2 w-full">
            <UpsConnectedAccountsTable upsQuery={upsQuery} setShouldOpenForm={setShouldOpenForm} />
          </div>
        ) : null}

        {((!isUpsAuthenticated && isUPSEnabled && !upsQuery.isFetching) || shouldOpenForm) && (
          <>
            <p>
              To add UPS parcel support in your Shipwell platform, enter the information below that you used to register
              your UPS account or sign up for an account at{' '}
              <a href="https://www.ups.com" target="_blank" rel="noreferrer">
                ups.com
              </a>
              .
            </p>
            <UPSRegistrationForm onCancel={handleCancel} onSubmit={handleSubmit} />
          </>
        )}
        {!isUPSEnabled && <p className="text-center">You don&apos;t have access to this integration.</p>}
        <Toast
          show={Boolean(submitError)}
          title="Error"
          variant="error"
          anchor="bottom-right"
          delay={null}
          onClose={() => setSubmitError(null)}
        >
          {submitError}
        </Toast>
      </div>
    </div>
  );
};

UPSRegistration.propTypes = {
  isUPSEnabled: PropTypes.bool,
  company: PropTypes.object
};

export default connect((state) => ({
  isUPSEnabled: state.company.company.feature_flags && state.company.company.feature_flags.ups_enabled,
  company: state.company.company
}))(UPSRegistration);
